module.exports = __webpack_public_path__ + "img/15.4c64a38a.jpg";